import React from 'react';

import classes from './MobileCloseBookingEngineButton.scss';
import closeImage from '../../../../assets/images/close.svg';

const mobileCloseBookingEngineButton = (props) => (
    <div {...props} className={classes.CloseButton}><img src={closeImage} alt="Close" /></div>
)

export default mobileCloseBookingEngineButton;


// WEBPACK FOOTER //
// ./src/components/UI/Mobile/MobileCloseBookingEngineButton/MobileCloseBookingEngineButton.js